import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { SubTitle } from 'features/organization_settings/shared/styles';
import { GroupSelect } from './group_select';
import { DeleteButton } from './styles';
const descriptionBlockCss = "dpvhsze";
const DescriptionBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionBlockCss, props.className)} />;
});
const groupSelectContainerCss = "gfdvesn";
const GroupSelectContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(groupSelectContainerCss, props.className)} />;
});
const containerCss = "c1tpyfar";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const DefaultGroup = () => {
  const [{
    value: defaultUserGroupId
  }, _meta, {
    setValue,
    setTouched
  }] = useFormField({
    name: 'defaultUserGroupId'
  });
  const onClear = useCallback(() => {
    setValue(null);
    setTouched(true);
  }, [setValue, setTouched]);
  return <Container>
      <SubTitle id="defaultGroupLabel">
        {I18n.t('publisher.organization_settings.user_provisioning.groups.default_group.title')}
      </SubTitle>
      <DescriptionBlock>
        {I18n.t('publisher.organization_settings.user_provisioning.groups.default_group.description')}
      </DescriptionBlock>
      <GroupSelectContainer>
        <div>
          <GroupSelect name="defaultUserGroupId" groupId={defaultUserGroupId} aria-labelledby="defaultGroupLabel" />
        </div>
        {defaultUserGroupId && <DeleteButton onClick={onClear} aria-label={I18n.t('publisher.organization_settings.user_provisioning.groups.default_group.clear_button')} />}
      </GroupSelectContainer>
    </Container>;
};

require("./default_group.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./default_group.js");